/**
 * Shared contract between the PDF template (BvaPdfDocument) and the export
 * pipeline (exportBvaPdf / autofitText). Kept in its own module so neither side
 * imports the other just to agree on a selector.
 */

/** The one-pager is a fixed 16:9 canvas. Figma frame 5228:34051. */
export const BVA_PDF_WIDTH = 1920
export const BVA_PDF_HEIGHT = 1080

/** id on the canvas root. The rasterizer captures this element. */
export const BVA_PDF_ROOT_ID = 'bva-pdf-canvas'

/**
 * A box with a known, fixed height whose content must fit inside it.
 *
 * `scrollHeight > clientHeight` is NOT a usable overflow signal for these
 * boxes: they centre (`justify-content: center`) or bottom-align
 * (`flex-end`) their content, and when a flex container's content overflows a
 * centred/end-aligned box the overflow escapes off the *top*, which
 * `scrollHeight` does not count. So each scope declares one measurable probe
 * child instead, and overflow is `probe height > scope clientHeight`.
 */
export const BVA_PDF_SCOPE_ATTRIBUTE = 'data-fit-scope'

/** The single measurable child of a scope. Compare against the scope's clientHeight. */
export const BVA_PDF_PROBE_ATTRIBUTE = 'data-fit-probe'

/** A text node whose font-size the fit routine may shrink. */
export const BVA_PDF_FIT_ATTRIBUTE = 'data-fit-group'

/** Smallest font-size, in px, a given fit node may be shrunk to. */
export const BVA_PDF_MIN_ATTRIBUTE = 'data-fit-min'
